import { render, staticRenderFns } from "./AdminTopNav.vue?vue&type=template&id=efb511aa"
import script from "./AdminTopNav.vue?vue&type=script&lang=js"
export * from "./AdminTopNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports